const emitInput = function(data, validator) {
  this.$emit('input', data)
  if (validator && validator.$touch) {
    validator.$touch()
  }
}

export { emitInput }
